import React, { useEffect, useState } from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import HomeReason from "./HomeReason";
import HomeFeatures from "./HomeFeatures";
import HomeExports from "./HomeExporst";
import PartnerWithUsSection from "./PartnerWithUs";
import ContactInquiry from "./ContactInquiry";
import Footer from "./Footer";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

export default function BannerNavbar({ backgroundImage = "yam.webp" }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    function onScroll() {
      setScrolled(window.scrollY > 40);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <Box sx={{ minHeight: "100vh", width: "100%" }}>
      {/* Navbar overlay */}
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          backgroundColor: scrolled ? "rgba(255,255,255,0.98)" : "transparent",
          color: scrolled ? "text.primary" : "common.white",
          boxShadow: scrolled ? 3 : "none",
          transition: "all 300ms ease",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <Container maxWidth="lg">
          <Toolbar
            disableGutters
            sx={{ display: "flex", justifyContent: "space-between" }}
          >
            {/* Logo */}
            <img
              src={scrolled ? "logo_white.png" : "logo_noBG.png"}
              alt="Tuberway Logo"
              style={{ height: 50, padding: 10 }}
            />

            {/* Desktop links */}
            <Box sx={{ display: { xs: "none", md: "flex" }, gap: 2 }}>
              <Button
                sx={{
                  textTransform: "none",
                  color: scrolled ? "black" : "white",
                }}
              >
                Gallery
              </Button>
            </Box>

            {/* Mobile menu icon */}
            <IconButton
              color="inherit"
              aria-label="menu"
              sx={{ display: { md: "none" } }}
            >
              <Button
                sx={{
                  textTransform: "none",
                  color: scrolled ? "black" : "white",
                }}
              >
                Gallery
              </Button>
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Banner */}
      <Box
        component="section"
        sx={{
          height: { xs: "60vh", sm: "72vh", md: "100vh" },
          width: "100%",
          backgroundImage: `linear-gradient(rgba(0,0,0,0.35), rgba(0,0,0,0.25)), url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
        }}
      >
        <Box
          sx={{
            backdropFilter: "blur(4px)",
            width: "100%",
            bgcolor: "black",
            height: "100%",
            position: "absolute",
            top: 0,
            left: 0,
            opacity: 0.4,
            zIndex: 1,
          }}
        ></Box>
        <Container
          maxWidth="md"
          sx={{ position: "absolute", zIndex: 2, textAlign: "center" }}
        >
          <Typography
            variant="h2"
            component="h1"
            sx={{
              color: "common.white",
              fontWeight: 800,
              mb: 2,
              fontSize: { xs: "2.2rem", sm: "3rem", md: "3rem" },
            }}
          >
            From Nigerian Soil to Every Table
          </Typography>
          <Typography
            variant="h6"
            sx={{
              color: "rgba(255,255,255,0.9)",
              mb: 4,
              fontSize: { xs: "0.9rem", sm: "1rem", md: "1rem" },
            }}
          >
            Supplying premium African yams to local kitchens and global markets.
          </Typography>
          <Box
            sx={{
              display: "flex",
              gap: 2,
              justifyContent: "center",
              flexWrap: "wrap",
            }}
          >
            <Button
              href="https://wa.me/2348146266425"
              target="_blank"
              rel="noopener noreferrer"
              startIcon={<WhatsAppIcon />}
              variant="contained"
              size="large"
              sx={{
                borderRadius: "20px",
                fontSize: "0.6rem",
                height: "40px",
                padding: "0 30px",
                bgcolor: "#AB6A32",
                fontWeight: "bold",
              }}
            >
              Get In Touch
            </Button>
          </Box>
        </Container>
      </Box>

      <HomeReason />
      <HomeFeatures />
      <HomeExports />
      <PartnerWithUsSection />
      <ContactInquiry />
      <Footer />
    </Box>
  );
}
